let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  // Bridge PubSub events to DOM CustomEvents for analytics tracking
  // This ensures tracking code (GA, FB Pixel, Mixpanel) receives cart events
  bridgeToDOMEvents(eventName, data);

  if (subscribers[eventName]) {
    const promises = subscribers[eventName]
      .map((callback) => callback(data))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}

/**
 * Bridge PubSub events to DOM CustomEvents for analytics tracking
 * Dispatches: cart:item-added, ajaxProduct:added, cart:item-removed, variant:change
 *
 * Debug: Set window.PUBSUB_DEBUG = true in console to see event logging
 */
function bridgeToDOMEvents(eventName, data) {
  const debug = window.PUBSUB_DEBUG || false;

  try {
    // Cart update events (add to cart)
    if (eventName === 'cart-update' && data && data.cartData) {
      const cartData = data.cartData;

      // Extract the added item from cart response
      // Shopify cart/add.js returns the added item directly, not the full cart
      // The response has: id (variant), product_id, title, variant_title, price, quantity, etc.
      let itemData = {};

      // Check if response is the added item (from /cart/add.js)
      if (cartData.product_id || cartData.id) {
        itemData = {
          product_id: cartData.product_id || cartData.id,
          product_title: cartData.product_title || cartData.title || '',
          variant_id: cartData.variant_id || cartData.id,
          variant_title: cartData.variant_title || '',
          product_price: cartData.price || cartData.final_price || 0,
          quantity: cartData.quantity || 1,
          sku: cartData.sku || '',
          vendor: cartData.vendor || '',
          product_type: cartData.product_type || ''
        };
      }
      // Check if it's a full cart response with items array
      else if (cartData.items && cartData.items.length > 0) {
        // Use the most recently added item (last in array) or try to find by variant ID
        let addedItem = cartData.items[cartData.items.length - 1];

        // If we have the variant ID from the publish call, find that specific item
        if (data.productVariantId) {
          const foundItem = cartData.items.find(item =>
            String(item.variant_id) === String(data.productVariantId) ||
            String(item.id) === String(data.productVariantId)
          );
          if (foundItem) addedItem = foundItem;
        }

        if (addedItem) {
          itemData = {
            product_id: addedItem.product_id,
            product_title: addedItem.product_title || addedItem.title || '',
            variant_id: addedItem.variant_id || addedItem.id,
            variant_title: addedItem.variant_title || '',
            product_price: addedItem.price || addedItem.final_price || 0,
            quantity: addedItem.quantity || 1,
            sku: addedItem.sku || '',
            vendor: addedItem.vendor || '',
            product_type: addedItem.product_type || ''
          };
        }
      }

      // Only dispatch if we have valid item data
      if (itemData.product_id) {
        if (debug) {
          console.log('[PubSub Bridge] Dispatching cart:item-added & ajaxProduct:added', itemData);
        }

        // Dispatch cart:item-added for data-layer.liquid and facebook-pixel.liquid
        document.dispatchEvent(new CustomEvent('cart:item-added', {
          detail: itemData,
          bubbles: true
        }));

        // Dispatch ajaxProduct:added for mixpanel-init.liquid
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: itemData,
          bubbles: true
        }));
      } else if (debug) {
        console.warn('[PubSub Bridge] cart-update received but no valid item data found', data);
      }
    }

    // Cart error events
    if (eventName === 'cart-error' && data) {
      document.dispatchEvent(new CustomEvent('cart:error', {
        detail: {
          message: data.message || data.errors || 'Cart error',
          variant_id: data.productVariantId,
          source: data.source
        },
        bubbles: true
      }));
    }

    // Variant change events (for product page tracking)
    if (eventName === 'variant-change' && data) {
      document.dispatchEvent(new CustomEvent('variant:change', {
        detail: {
          variant: data.variant || data,
          product_id: data.product_id,
          source: data.source
        },
        bubbles: true
      }));
    }

    // Quantity update events (for cart modifications)
    if (eventName === 'quantity-update' && data) {
      // Check if item was removed (quantity = 0)
      if (data.quantity === 0 || data.removed) {
        document.dispatchEvent(new CustomEvent('cart:item-removed', {
          detail: {
            product_id: data.product_id,
            variant_id: data.variant_id,
            product_title: data.product_title || '',
            quantity: data.previous_quantity || 1
          },
          bubbles: true
        }));
      }
    }
  } catch (e) {
    // Silent fail - never break cart functionality for analytics
    if (window.console && window.console.warn) {
      console.warn('[PubSub Bridge] Error dispatching DOM event:', e);
    }
  }
}
